import React from 'react'

import CollectionMainPage from "../page/CollectionMainPage"

function JaipurisetPage( {categoryType}) {
  return (

    <CollectionMainPage categoryType={categoryType}/>
   
  )
}

export default JaipurisetPage